import type { FirmBaseLayoutLegacyContextValue } from './LayoutContext.types';

const noop = () => {};

// LayoutContext is still the legacy shell bridge.
// Keep defaults explicit so legacy consumers can safely render in tests or temporary wrappers.
export const DEFAULT_LAYOUT_CONTEXT_VALUE: FirmBaseLayoutLegacyContextValue = {
  currentFirmRole: null,
  exportTab: '',
  isExportMode: false,
  openBulkActionsDialog: false,
  openPdfDialog: false,
  pageFilters: null,
  setPageFilters: noop,
  setShowAlert: noop,
  showAlert: false,
  toggleBulkActionsDialog: noop,
  togglePdfDialog: noop,
  updateExtraPageActions: noop,
  updatePageActions: noop,
  viewOnlyUser: false,
};
